/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliActivityForParentDto } from '../../models/amoxcalli-activity-for-parent-dto';

export interface ApiActivitiesForParentGet$Json$Params {
  studentId?: string;
}

export function apiActivitiesForParentGet$Json(http: HttpClient, rootUrl: string, params?: ApiActivitiesForParentGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliActivityForParentDto>>> {
  const rb = new RequestBuilder(rootUrl, apiActivitiesForParentGet$Json.PATH, 'get');
  if (params) {
    rb.query('studentId', params.studentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliActivityForParentDto>>;
    })
  );
}

apiActivitiesForParentGet$Json.PATH = '/api/activities/for-parent';
